import { render, staticRenderFns } from "./WorkflowSettings.vue?vue&type=template&id=13775b48&scoped=true&"
import script from "./WorkflowSettings.vue?vue&type=script&lang=ts&"
export * from "./WorkflowSettings.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowSettings.vue?vue&type=style&index=0&id=13775b48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13775b48",
  null
  
)

export default component.exports